import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import RootStoreContext from '~/contexts/RootStoreContext';
import { actions as modalActions } from '~/domains/modal';
import { selectors as agentScannersSelectors } from '~/domains/agentScanners';
import {
  actions as commonActions,
  selectors as commonSelectors
} from '~/domains/common';
import DeleteConfirmModal from '../ScanConfigurationActions/DeleteConfirmModal';
import ScanConfigurationsListComponent from './ScanConfigurationsList';

/**
 * Container for ScanConfigurationsList component
 * Connects to Redux store following the same pattern as other containers
 */

const mapStateToProps = (state, ownProps) => {
  const profile = commonSelectors.profile(state);
  const organization = profile?.organization;
  const organizationId = organization?.id;

  return {
    // Use filtered data from props if available, otherwise use Redux data
    scanConfigurations:
      ownProps.scanConfigurations || agentScannersSelectors.scanners(state),
    isFetchingScanConfigurations:
      agentScannersSelectors.isFetchingScanners(state),
    scannersError: agentScannersSelectors.scannersError(state),

    // Organization context
    organizationId,
    alert: commonSelectors.alert(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  // Import actions dynamically to avoid circular dependencies
  // eslint-disable-next-line global-require
  const { actions: agentScannersActions } = require('~/domains/agentScanners');

  return {
    // Action creators
    onCloseAlert: () => dispatch(commonActions.closeAlert()),
    openModal: ({ modalType, modalProps }) =>
      dispatch(modalActions.openModal({ modalType, modalProps })),
    onLoadScanConfigurations: (organizationId) =>
      dispatch(agentScannersActions.loadAgentScanners(organizationId)),

    // Use the handler from parent props, or fallback to no-op
    onScanConfigurationClick:
      ownProps.onScanConfigurationClick ||
      (() => {
        // Fallback handler - no action needed
      }),

    onRunNowClick: (organizationId, scanConfig) => {
      dispatch(
        agentScannersActions.runScanConfiguration(organizationId, scanConfig.id)
      );

      // TODO: Abort action
      const runAlert = {
        type: 'info',
        message: `Your '${scanConfig.name}' is currently updating.<br>Click <a onclick="() => null">Abort</a> if you need to stop it now.`,
        isHTML: true
      };

      dispatch(commonActions.setAlert(runAlert));
    },

    onEditScannerClick: () => {
      // TODO: Edit Scanner action
    },

    onDeleteScannerClick: (scanConfigId) => {
      // TODO: Delete scanner action
      dispatch(
        modalActions.openModal({
          modalType: DeleteConfirmModal.modalType,
          modalProps: {
            scanConfigId
          }
        })
      );
    },

    onAddScanner:
      ownProps.onAddScanner ||
      (() => {
        // Fallback handler - no action needed
      })
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onRunNowClick: (scanConfig) =>
    dispatchProps.onRunNowClick(stateProps.organizationId, scanConfig)
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps, {
    context: RootStoreContext
  })
)(ScanConfigurationsListComponent);
